export default __webpack_public_path__ + "static/media/sam-and-karen-sounders.67d32349.jpeg";